import { Fragment, useEffect } from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const Retention = ({
  formValuesDetailsSummary,
  setFormValuesDetailsSummary,
  autorizedReport = false,
}) => {
  const { regimeSatCode } = useParams();

  const { retentions } = useSelector((state) => state.retention);
  const { typeRetention } = useSelector((state) => state.typeRetention);

  const { taxISRPlataformsTechnologies, taxIVAPlataformsTechnologies } =
    formValuesDetailsSummary;

  // const [retentionPlataforms, setRetentionPlataforms] = useState([]);

  useEffect(() => {
    // setRetentionPlataforms([]);
    let totalPassengerPlataform = 0.0;
    let totalDealerPlataform = 0.0;
    let isrGround = 0.0;

    let totalLodgingPlataform = 0.0;
    let isrLodging = 0.0;

    let totalAlienationPlataform = 0.0;
    let totalLendingPlataform = 0.0;
    let isrAlienation = 0.0;

    let ivaPlataform = 0.0;

    if (regimeSatCode === "625") {
      if (retentions.length > 0) {
        // acumulador para sumar el IVA de comisión de todos los retentions
        let ivaComisionSum = 0;
        retentions.forEach((retention) => {
          let isrConsidered = false;
          if (typeRetention.includes(retention.cveRetenc.key.toString())) {
            // setRetentionPlataforms(prevState=> {return[...prevState, retention]});
            retention.complement.Any.forEach((complement) => {
              if (
                complement["ServiciosPlataformasTecnologicas"] !== undefined
              ) {
                if (
                  Array.isArray(
                    complement["ServiciosPlataformasTecnologicas"]["Servicios"][
                      "DetallesDelServicio"
                    ]
                  )
                ) {
                  complement["ServiciosPlataformasTecnologicas"]["Servicios"][
                    "DetallesDelServicio"
                  ].forEach((detalle) => {
                    if (detalle["@TipoDeServ"] === "01") {
                      if (
                        detalle["ImpuestosTrasladadosdelServicio"] === undefined
                      ) {
                        totalPassengerPlataform = (
                          parseFloat(totalPassengerPlataform) +
                          parseFloat(detalle["@PrecioServSinIVA"])
                        ).toFixed(2);
                      }
                      if (
                        detalle["ImpuestosTrasladadosdelServicio"] !== undefined
                      ) {
                        totalPassengerPlataform = (
                          parseFloat(totalPassengerPlataform) +
                          parseFloat(
                            detalle["ImpuestosTrasladadosdelServicio"]["@Base"]
                          )
                        ).toFixed(2);
                      }
                      retention.totals.ImpRetenidos.forEach((tax) => {
                        if (!isrConsidered) {
                          if (tax.Impuesto === 0) {
                            isrGround = (
                              parseFloat(isrGround) +
                              parseFloat(parseFloat(tax.montoRet))
                            ).toFixed(2);
                            isrConsidered = true;
                          }
                          if (tax.ImpuestoRet === 0) {
                            isrGround = (
                              parseFloat(isrGround) +
                              parseFloat(parseFloat(tax.MontoRet))
                            ).toFixed(2);
                            isrConsidered = true;
                          }
                        }
                      });
                    }
                    if (
                      detalle["@TipoDeServ"] === "02" ||
                      detalle["@TipoDeServ"] === "03"
                    ) {
                      if (
                        detalle["ImpuestosTrasladadosdelServicio"] === undefined
                      ) {
                        totalDealerPlataform = (
                          parseFloat(totalDealerPlataform) +
                          parseFloat(detalle["@PrecioServSinIVA"])
                        ).toFixed(2);
                      }
                      if (
                        detalle["ImpuestosTrasladadosdelServicio"] !== undefined
                      ) {
                        totalDealerPlataform = (
                          parseFloat(totalDealerPlataform) +
                          parseFloat(
                            detalle["ImpuestosTrasladadosdelServicio"]["@Base"]
                          )
                        ).toFixed(2);
                      }
                      retention.totals.ImpRetenidos.forEach((tax) => {
                        if (!isrConsidered) {
                          if (tax.Impuesto === 0) {
                            isrGround = (
                              parseFloat(isrGround) + parseFloat(tax.montoRet)
                            ).toFixed(2);
                            isrConsidered = true;
                          }
                          if (tax.ImpuestoRet === 0) {
                            isrGround = (
                              parseFloat(isrGround) + parseFloat(tax.MontoRet)
                            ).toFixed(2);
                            isrConsidered = true;
                          }
                        }
                      });
                    }
                    if (detalle["@TipoDeServ"] === "04") {
                      if (
                        detalle["ImpuestosTrasladadosdelServicio"] === undefined
                      ) {
                        totalLodgingPlataform = (
                          parseFloat(totalLodgingPlataform) +
                          parseFloat(detalle["@PrecioServSinIVA"])
                        ).toFixed(2);
                      }
                      if (
                        detalle["ImpuestosTrasladadosdelServicio"] !== undefined
                      ) {
                        totalLodgingPlataform = (
                          parseFloat(totalLodgingPlataform) +
                          parseFloat(
                            detalle["ImpuestosTrasladadosdelServicio"]["@Base"]
                          )
                        ).toFixed(2);
                      }
                      retention.totals.ImpRetenidos.forEach((tax) => {
                        if (!isrConsidered) {
                          if (tax.Impuesto === 0) {
                            isrLodging = (
                              parseFloat(isrLodging) + parseFloat(tax.montoRet)
                            ).toFixed(2);
                            isrConsidered = true;
                          }
                          if (tax.ImpuestoRet === 0) {
                            isrLodging = (
                              parseFloat(isrLodging) + parseFloat(tax.MontoRet)
                            ).toFixed(2);
                            isrConsidered = true;
                          }
                        }
                      });
                    }
                    if (detalle["@TipoDeServ"] === "05") {
                      if (
                        detalle["ImpuestosTrasladadosdelServicio"] === undefined
                      ) {
                        totalAlienationPlataform = (
                          parseFloat(totalAlienationPlataform) +
                          parseFloat(detalle["@PrecioServSinIVA"])
                        ).toFixed(2);
                      }
                      if (
                        detalle["ImpuestosTrasladadosdelServicio"] !== undefined
                      ) {
                        totalAlienationPlataform = (
                          parseFloat(totalAlienationPlataform) +
                          parseFloat(
                            detalle["ImpuestosTrasladadosdelServicio"]["@Base"]
                          )
                        ).toFixed(2);
                      }
                      retention.totals.ImpRetenidos.forEach((tax) => {
                        if (!isrConsidered) {
                          if (tax.Impuesto === 0) {
                            isrAlienation = (
                              parseFloat(isrAlienation) +
                              parseFloat(tax.montoRet)
                            ).toFixed(2);
                            isrConsidered = true;
                          }
                          if (tax.ImpuestoRet === 0) {
                            isrAlienation = (
                              parseFloat(isrAlienation) +
                              parseFloat(tax.MontoRet)
                            ).toFixed(2);
                            isrConsidered = true;
                          }
                        }
                      });
                    }
                    if (detalle["@TipoDeServ"] === "06") {
                      if (
                        detalle["ImpuestosTrasladadosdelServicio"] === undefined
                      ) {
                        totalLendingPlataform = (
                          parseFloat(totalLendingPlataform) +
                          parseFloat(detalle["@PrecioServSinIVA"])
                        ).toFixed(2);
                      }
                      if (
                        detalle["ImpuestosTrasladadosdelServicio"] !== undefined
                      ) {
                        totalLendingPlataform = (
                          parseFloat(totalLendingPlataform) +
                          parseFloat(
                            detalle["ImpuestosTrasladadosdelServicio"]["@Base"]
                          )
                        ).toFixed(2);
                      }
                      retention.totals.ImpRetenidos.forEach((tax) => {
                        if (!isrConsidered) {
                          if (tax.Impuesto === 0) {
                            isrAlienation = (
                              parseFloat(isrAlienation) +
                              parseFloat(tax.montoRet)
                            ).toFixed(2);
                            isrConsidered = true;
                          }
                          if (tax.ImpuestoRet === 0) {
                            isrAlienation = (
                              parseFloat(isrAlienation) +
                              parseFloat(tax.MontoRet)
                            ).toFixed(2);
                            isrConsidered = true;
                          }
                        }
                      });
                    }
                  });
                } else {
                  let detalle =
                    complement["ServiciosPlataformasTecnologicas"]["Servicios"][
                      "DetallesDelServicio"
                    ];
                  if (detalle["@TipoDeServ"] === "01") {
                    if (
                      detalle["ImpuestosTrasladadosdelServicio"] === undefined
                    ) {
                      totalPassengerPlataform = (
                        parseFloat(totalPassengerPlataform) +
                        parseFloat(detalle["@PrecioServSinIVA"])
                      ).toFixed(2);
                    }
                    if (
                      detalle["ImpuestosTrasladadosdelServicio"] !== undefined
                    ) {
                      totalPassengerPlataform = (
                        parseFloat(totalPassengerPlataform) +
                        parseFloat(
                          detalle["ImpuestosTrasladadosdelServicio"]["@Base"]
                        )
                      ).toFixed(2);
                    }
                    retention.totals.ImpRetenidos.forEach((tax) => {
                      if (!isrConsidered) {
                        if (tax.Impuesto === 0) {
                          isrGround = (
                            parseFloat(isrGround) + parseFloat(tax.montoRet)
                          ).toFixed(2);
                          isrConsidered = true;
                        }
                        if (tax.ImpuestoRet === 0) {
                          isrGround = (
                            parseFloat(isrGround) + parseFloat(tax.MontoRet)
                          ).toFixed(2);
                          isrConsidered = true;
                        }
                      }
                    });
                  }
                  if (
                    detalle["@TipoDeServ"] === "02" ||
                    detalle["@TipoDeServ"] === "03"
                  ) {
                    if (
                      detalle["ImpuestosTrasladadosdelServicio"] === undefined
                    ) {
                      totalDealerPlataform = (
                        parseFloat(totalDealerPlataform) +
                        parseFloat(detalle["@PrecioServSinIVA"])
                      ).toFixed(2);
                    }
                    if (
                      detalle["ImpuestosTrasladadosdelServicio"] !== undefined
                    ) {
                      totalDealerPlataform = (
                        parseFloat(totalDealerPlataform) +
                        parseFloat(
                          detalle["ImpuestosTrasladadosdelServicio"]["@Base"]
                        )
                      ).toFixed(2);
                    }
                    retention.totals.ImpRetenidos.forEach((tax) => {
                      if (!isrConsidered) {
                        if (tax.Impuesto === 0) {
                          isrGround = (
                            parseFloat(isrGround) + parseFloat(tax.montoRet)
                          ).toFixed(2);
                          isrConsidered = true;
                        }
                        if (tax.ImpuestoRet === 0) {
                          isrGround = (
                            parseFloat(isrGround) + parseFloat(tax.MontoRet)
                          ).toFixed(2);
                          isrConsidered = true;
                        }
                      }
                    });
                  }
                  if (detalle["@TipoDeServ"] === "04") {
                    if (
                      detalle["ImpuestosTrasladadosdelServicio"] === undefined
                    ) {
                      totalLodgingPlataform = (
                        parseFloat(totalLodgingPlataform) +
                        parseFloat(detalle["@PrecioServSinIVA"])
                      ).toFixed(2);
                    }
                    if (
                      detalle["ImpuestosTrasladadosdelServicio"] !== undefined
                    ) {
                      totalLodgingPlataform = (
                        parseFloat(totalLodgingPlataform) +
                        parseFloat(
                          detalle["ImpuestosTrasladadosdelServicio"]["@Base"]
                        )
                      ).toFixed(2);
                    }
                    retention.totals.ImpRetenidos.forEach((tax) => {
                      if (!isrConsidered) {
                        if (tax.Impuesto === 0) {
                          isrLodging = (
                            parseFloat(isrLodging) + parseFloat(tax.montoRet)
                          ).toFixed(2);
                          isrConsidered = true;
                        }
                        if (tax.ImpuestoRet === 0) {
                          isrLodging = (
                            parseFloat(isrLodging) + parseFloat(tax.MontoRet)
                          ).toFixed(2);
                          isrConsidered = true;
                        }
                      }
                    });
                  }
                  if (detalle["@TipoDeServ"] === "05") {
                    if (
                      detalle["ImpuestosTrasladadosdelServicio"] === undefined
                    ) {
                      totalAlienationPlataform = (
                        parseFloat(totalAlienationPlataform) +
                        parseFloat(detalle["@PrecioServSinIVA"])
                      ).toFixed(2);
                    }
                    if (
                      detalle["ImpuestosTrasladadosdelServicio"] !== undefined
                    ) {
                      totalAlienationPlataform = (
                        parseFloat(totalAlienationPlataform) +
                        parseFloat(
                          detalle["ImpuestosTrasladadosdelServicio"]["@Base"]
                        )
                      ).toFixed(2);
                    }
                    retention.totals.ImpRetenidos.forEach((tax) => {
                      if (!isrConsidered) {
                        if (tax.Impuesto === 0) {
                          isrAlienation = (
                            parseFloat(isrAlienation) + parseFloat(tax.montoRet)
                          ).toFixed(2);
                          isrConsidered = true;
                        }
                        if (tax.ImpuestoRet === 0) {
                          isrAlienation = (
                            parseFloat(isrAlienation) + parseFloat(tax.MontoRet)
                          ).toFixed(2);
                          isrConsidered = true;
                        }
                      }
                    });
                  }
                  if (detalle["@TipoDeServ"] === "06") {
                    if (
                      detalle["ImpuestosTrasladadosdelServicio"] === undefined
                    ) {
                      totalLendingPlataform = (
                        parseFloat(totalLendingPlataform) +
                        parseFloat(detalle["@PrecioServSinIVA"])
                      ).toFixed(2);
                    }
                    if (
                      detalle["ImpuestosTrasladadosdelServicio"] !== undefined
                    ) {
                      totalLendingPlataform = (
                        parseFloat(totalLendingPlataform) +
                        parseFloat(
                          detalle["ImpuestosTrasladadosdelServicio"]["@Base"]
                        )
                      ).toFixed(2);
                    }
                    retention.totals.ImpRetenidos.forEach((tax) => {
                      if (!isrConsidered) {
                        if (tax.Impuesto === 0) {
                          isrAlienation = (
                            parseFloat(isrAlienation) + parseFloat(tax.montoRet)
                          ).toFixed(2);
                          isrConsidered = true;
                        }
                        if (tax.ImpuestoRet === 0) {
                          isrAlienation = (
                            parseFloat(isrAlienation) + parseFloat(tax.MontoRet)
                          ).toFixed(2);
                          isrConsidered = true;
                        }
                      }
                    });
                  }
                }
              }
            });

            retention.totals.ImpRetenidos.forEach((tax) => {
              if (tax.Impuesto === 1) {
                ivaPlataform = (
                  parseFloat(ivaPlataform) + parseFloat(tax.montoRet)
                ).toFixed(2);
              }
              if (tax.ImpuestoRet === 1) {
                ivaPlataform = (
                  parseFloat(ivaPlataform) + parseFloat(tax.MontoRet)
                ).toFixed(2);
              }
            });
          }

          const isrJsonRetention = taxISRPlataformsTechnologies;

          const ivaJsonRetention = taxIVAPlataformsTechnologies;

          let totalPassengerPlataformFinal = totalPassengerPlataform;

          if (
            parseFloat(
              isrJsonRetention.serviceGround.totalPassengerPlataform
            ) !== 0 &&
            parseFloat(isrJsonRetention.serviceGround.totalPassengerPlataform) >
              parseFloat(totalPassengerPlataform)
          ) {
            totalPassengerPlataformFinal = parseFloat(
              isrJsonRetention.serviceGround.totalPassengerPlataform
            ).toFixed(2);
          }

          let totalDealerPlataformFinal = totalDealerPlataform;
          if (
            parseFloat(isrJsonRetention.serviceGround.totalDealerPlataform) !==
              0 &&
            parseFloat(isrJsonRetention.serviceGround.totalDealerPlataform) >
              parseFloat(totalDealerPlataform)
          ) {
            totalDealerPlataformFinal = parseFloat(
              isrJsonRetention.serviceGround.totalDealerPlataform
            ).toFixed(2);
          }

          let isrGroundFinal = isrGround;
          if (
            parseFloat(isrJsonRetention.serviceGround.totalRetained) !== 0 &&
            parseFloat(isrJsonRetention.serviceGround.totalRetained) !==
              parseFloat(isrGround)
          ) {
            isrGroundFinal = parseFloat(
              isrJsonRetention.serviceGround.totalRetained
            ).toFixed(2);
          }

          let totalLodgingPlataformFinal = totalLodgingPlataform;
          if (
            parseFloat(
              isrJsonRetention.serviceLodging.totalLodgingPlataform
            ) !== 0 &&
            parseFloat(isrJsonRetention.serviceLodging.totalLodgingPlataform) >
              parseFloat(totalLodgingPlataform)
          ) {
            totalLodgingPlataformFinal = parseFloat(
              isrJsonRetention.serviceLodging.totalLodgingPlataform
            ).toFixed(2);
          }

          let isrLodgingFinal = isrLodging;
          if (
            parseFloat(isrJsonRetention.serviceLodging.totalRetained) !== 0 &&
            parseFloat(isrJsonRetention.serviceLodging.totalRetained) !==
              parseFloat(isrLodging)
          ) {
            isrLodgingFinal = parseFloat(
              isrJsonRetention.serviceLodging.totalRetained
            ).toFixed(2);
          }

          let totalLendingPlataformFinal = totalLendingPlataform;
          if (
            parseFloat(
              isrJsonRetention.serviceAlienation.totalLendingPlataform
            ) !== 0 &&
            parseFloat(
              isrJsonRetention.serviceAlienation.totalLendingPlataform
            ) > parseFloat(totalLendingPlataform)
          ) {
            totalLendingPlataformFinal = parseFloat(
              isrJsonRetention.serviceAlienation.totalLendingPlataform
            ).toFixed(2);
          }

          let totalAlienationPlataformFinal = totalAlienationPlataform;
          if (
            parseFloat(
              isrJsonRetention.serviceAlienation.totalAlienationPlataform
            ) !== 0 &&
            parseFloat(
              isrJsonRetention.serviceAlienation.totalAlienationPlataform
            ) > parseFloat(totalAlienationPlataform)
          ) {
            totalAlienationPlataformFinal = parseFloat(
              isrJsonRetention.serviceAlienation.totalAlienationPlataform
            ).toFixed(2);
          }

          let isrAlienationFinal = isrAlienation;
          if (
            parseFloat(isrJsonRetention.serviceAlienation.totalRetained) !==
              0 &&
            parseFloat(isrJsonRetention.serviceAlienation.totalRetained) !==
              parseFloat(isrAlienation)
          ) {
            isrAlienationFinal = parseFloat(
              isrJsonRetention.serviceAlienation.totalRetained
            ).toFixed(2);
          }

          let ivaPlataformFinal = ivaPlataform;
          if (
            parseFloat(ivaJsonRetention.retentionPlataform) !== 0 &&
            parseFloat(ivaJsonRetention.retentionPlataform) !==
              parseFloat(ivaPlataform)
          ) {
            ivaPlataformFinal = parseFloat(
              ivaJsonRetention.retentionPlataform
            ).toFixed(2);
          }

          // Acumula el IVA de comisión si existe en el objeto retention
          // Si no existe, intentamos calcularlo a partir de la comisión del servicio
          // usando la tasa definida en taxIVAPlataformsTechnologies.optionIva.porcentage
          const rawIvaComision = parseFloat(retention.ivaComision || 0);
          let ivaFromCommission = rawIvaComision;
          if (!rawIvaComision || rawIvaComision === 0) {
            const commission = parseFloat(retention.comisionServicio || 0);
            const rate =
              (ivaJsonRetention &&
                ivaJsonRetention.optionIva &&
                ivaJsonRetention.optionIva.porcentage) ||
              0.16;
            ivaFromCommission = parseFloat((commission * rate).toFixed(2));
          }
          ivaComisionSum += isNaN(ivaFromCommission) ? 0 : ivaFromCommission;

          setFormValuesDetailsSummary((prevState) => {
            return {
              ...prevState,
              taxISRPlataformsTechnologies: {
                ...prevState.taxISRPlataformsTechnologies,
                serviceAlienation: {
                  ...prevState.taxISRPlataformsTechnologies.serviceAlienation,
                  totalLendingPlataform: totalLendingPlataformFinal,
                  totalAlienationPlataform: totalAlienationPlataformFinal,
                  totalRetained: isrAlienationFinal,
                },
                serviceGround: {
                  ...prevState.taxISRPlataformsTechnologies.serviceGround,
                  totalPassengerPlataform: totalPassengerPlataformFinal,
                  totalDealerPlataform: totalDealerPlataformFinal,
                  totalRetained: isrGroundFinal,
                },
                serviceLodging: {
                  ...prevState.taxISRPlataformsTechnologies.serviceLodging,
                  totalLodgingPlataform: totalLodgingPlataformFinal,
                  totalRetained: isrLodgingFinal,
                },
              },
              taxIVAPlataformsTechnologies: {
                ...prevState.taxIVAPlataformsTechnologies,
                retentionPlataform: ivaPlataformFinal,
              },
            };
          });
        });

        // Una vez procesadas todas las retenciones, fijamos el total de IVA de comisiones
        // Guardamos como número y con precisión suficiente (no redondear a 2 decimales aquí)
        const ivaComisionValue = isNaN(ivaComisionSum) ? 0 : ivaComisionSum;
        setFormValuesDetailsSummary((prevState) => {
          return {
            ...prevState,
            taxIVAPlataformsTechnologies: {
              ...prevState.taxIVAPlataformsTechnologies,
              ivaComisionFromRetentions: Number(ivaComisionValue),
            },
          };
        });
      }
    }
  }, [retentions, setFormValuesDetailsSummary, typeRetention]);

  /* useEffect(() => {
    if(retentions.length > 0){
      const canceleds = canceledsRetentions(retentions);
      setFormValues(prevState => {
        return{
          ...prevState,
          canceledRetentions: [...canceleds]
        }
      })
    }
  }, [retentions, setFormValues]); */

  // Preparar totales para la fila final de la tabla
  const visibleRetentions = retentions.filter(
    (retention) =>
      retention.totals &&
      retention.totals.ImpRetenidos &&
      typeRetention.includes(retention.cveRetenc.key.toString())
  );

  let totalIva = 0;
  let totalIsr = 0;
  let totalReceived = 0;
  let totalComisionServicio = 0;
  let totalIvaComision = 0;

  visibleRetentions.forEach((retention) => {
    (retention.totals.ImpRetenidos || []).forEach((tax) => {
      const ivaVal = parseFloat(tax.montoRet ?? tax.MontoRet ?? 0) || 0;
      const isrVal = parseFloat(tax.montoRet ?? tax.MontoRet ?? 0) || 0;
      if (tax.Impuesto === 1 || tax.ImpuestoRet === 1) totalIva += ivaVal;
      if (tax.Impuesto === 0 || tax.ImpuestoRet === 0) totalIsr += isrVal;
    });

    const received =
      parseFloat(
        retention.totals.MontoTotOperacion ??
          retention.totals.montoTotOperacion ??
          0
      ) || 0;
    totalReceived += received;

    const commission = parseFloat(retention.comisionServicio ?? 0) || 0;
    totalComisionServicio += commission;

    let ivaCom = parseFloat(retention.ivaComision ?? 0) || 0;
    if (!ivaCom) ivaCom = parseFloat((commission * 0.16).toFixed(6)) || 0;
    totalIvaComision += ivaCom;
  });

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
        <div className="card">
          <div className="card-header">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <h5>Retenciones</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr className="text-center">
                <th>UUID</th>
                <th>Fecha de timbrado</th>
                <th>Retenedor</th>
                <th>Folio</th>
                <th>Tipo Retención</th>
                <th>IVA</th>
                <th>ISR</th>
                <th>Total Recibido</th>
                <th>Comisión del Servicio</th>
                <th>Iva de Comisión</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {retentions.length === 0 ? (
                <tr>
                  <td colSpan="11">
                    <div
                      className="alert alert-primary text-center mb-0"
                      role="alert"
                    >
                      No se ha encontrado información
                    </div>
                  </td>
                </tr>
              ) : (
                visibleRetentions.map((retention) => {
                  return (
                    <tr key={retention.id}>
                      <td align="center">{retention.uuid}</td>
                      <td align="center">{retention.tfdStampedAt}</td>
                      <td align="center">
                        {retention.issuedFullName}
                        <br />
                        {retention.issuedRfc}
                      </td>
                      <td align="center">{retention.folioInt}</td>
                      <td align="center">{retention.cveRetenc.description}</td>
                      <td>
                        {retention.totals.ImpRetenidos.map((total, index) => {
                          switch (retention.retentionVersion) {
                            case "RETEN10":
                              return (
                                total.Impuesto === 1 && (
                                  <Fragment key={index}>
                                    <NumberFormat
                                      value={parseFloat(total.montoRet)}
                                      displayType="text"
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      prefix="$ "
                                    />
                                  </Fragment>
                                )
                              );
                            case "RETEN20":
                              return (
                                total.ImpuestoRet === 1 && (
                                  <Fragment key={index}>
                                    <NumberFormat
                                      value={parseFloat(total.MontoRet)}
                                      displayType="text"
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      prefix="$ "
                                    />
                                  </Fragment>
                                )
                              );
                            default:
                              return null;
                          }
                        })}
                      </td>
                      <td>
                        {retention.totals.ImpRetenidos.map((total, index) => {
                          switch (retention.retentionVersion) {
                            case "RETEN10":
                              return (
                                total.Impuesto === 0 && (
                                  <Fragment key={index}>
                                    <NumberFormat
                                      value={parseFloat(total.montoRet)}
                                      displayType="text"
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      prefix="$ "
                                    />
                                  </Fragment>
                                )
                              );
                            case "RETEN20":
                              return (
                                total.ImpuestoRet === 0 && (
                                  <Fragment key={index}>
                                    <NumberFormat
                                      value={parseFloat(total.MontoRet)}
                                      displayType="text"
                                      thousandSeparator={true}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      prefix="$ "
                                    />
                                  </Fragment>
                                )
                              );
                            default:
                              return null;
                          }
                        })}
                      </td>
                      <td align="center">
                        <NumberFormat
                          value={parseFloat(
                            retention.totals.montoTotOperacion ??
                              retention.totals.MontoTotOperacion ??
                              0
                          )}
                          displayType="text"
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          prefix="$ "
                        />
                      </td>
                      <td align="center">
                        <NumberFormat
                          value={parseFloat(retention.comisionServicio ?? 0)}
                          displayType="text"
                          thousandSeparator={true}
                          decimalScale={4}
                          fixedDecimalScale={true}
                          prefix="$ "
                        />
                      </td>
                      <td align="center">
                        <NumberFormat
                          value={parseFloat(retention.ivaComision ?? 0)}
                          displayType="text"
                          thousandSeparator={true}
                          decimalScale={6}
                          fixedDecimalScale={true}
                          prefix="$ "
                        />
                      </td>
                      <td></td>
                    </tr>
                  );
                })
              )}
              {visibleRetentions.length > 0 && (
                <tr className="font-weight-bold bg-light">
                  <td></td>
                  <td></td>
                  <td className="text-right">Totales:</td>
                  <td></td>
                  <td></td>
                  <td className="text-center">
                    <NumberFormat
                      value={totalIva}
                      displayType="text"
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix="$ "
                    />
                  </td>
                  <td className="text-center">
                    <NumberFormat
                      value={totalIsr}
                      displayType="text"
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix="$ "
                    />
                  </td>
                  <td className="text-center">
                    <NumberFormat
                      value={totalReceived}
                      displayType="text"
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      prefix="$ "
                    />
                  </td>
                  <td className="text-center">
                    <NumberFormat
                      value={totalComisionServicio}
                      displayType="text"
                      thousandSeparator={true}
                      decimalScale={4}
                      fixedDecimalScale={true}
                      prefix="$ "
                    />
                  </td>
                  <td className="text-center">
                    <NumberFormat
                      value={totalIvaComision}
                      displayType="text"
                      thousandSeparator={true}
                      decimalScale={6}
                      fixedDecimalScale={true}
                      prefix="$ "
                    />
                  </td>
                  <td></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Retention;
